import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import {
  Route as pathlessAuthenticatedRoute,
  requirePermission,
} from '../route';

const WorkflowAdminPage = lazyRouteComponent(
  () => import('./WorkflowAdminPage'),
  'WorkflowAdminPage',
);

/**
 * Hidden workflow triage page. Requires WorkflowAdmin.Read. Deliberately has
 * NO nav entry — reach it directly at /workflow-admin. Built for incidents
 * like the 2026-08 AP-ingestion fanout OOM: terminate whole run trees (root
 * + abandoned fanout children) and bulk-cancel scheduled snooze reruns.
 */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/workflow-admin',
  staticData: {
    app: {
      access: {
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.WorkflowAdmin },
        ],
      },
    },
  },
  component: WorkflowAdminPage,
  loader: () => ({
    crumb: msg('Workflow Admin Triage', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.WorkflowAdmin,
    });
  },
});
